import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import * as AbstractionsYaDelivery from "@helper/abstraction/yandex-delivery";
import { DocumentController } from "./document-controller";
import { ConfigurationService } from "@core/configuration.service";

export class Yandex extends DocumentController<any> {
	public get apiUrl(): string { 
		return `${this.config.api.delivery}`; 
	}
    private apiProxyUrl = "/api/v1/yandex-delivery-proxy";

	constructor(
		private config: ConfigurationService,
		http: HttpClient
	) {
		super(http);
	}

    public getDeliveryOptions = {
        post$: (data: AbstractionsYaDelivery.OfferCalculate): Observable<AbstractionsYaDelivery.Offers> => {
			const url = "https://b2b.taxi.yandex.net/cargo/integration/v2/offers/calculate";
            const options = {
                headers: {
                    "Accept-Language": "ru-RU",
                },
                body: data,
                // withCredentials: true
            };
			return this.http.post<AbstractionsYaDelivery.Offers>(url, options);
		},
    }

	public yandex = {
		offers: {
			post$: (data: AbstractionsYaDelivery.OfferCalculate): Observable<AbstractionsYaDelivery.Offers> => {
				const url = `${this.apiProxyUrl}/offers/calculate`;
				const options = {
					headers: new HttpHeaders({
						"Accept-Language": "ru",
					}),
					body: data
				};
				return this.http.post<AbstractionsYaDelivery.Offers>(url, options.body, { headers: options.headers });
			}
		}
	};

	public claims = {
		create: {
			post$: (data: AbstractionsYaDelivery.ClaimsDTO, document_id: number): Observable<AbstractionsYaDelivery.ClaimsDTO> => {
				const url = `${this.apiProxyUrl}/claims/create`;
				let params = new HttpParams();
				params = params.set("document_id", document_id);
				const options = {
					headers: new HttpHeaders({
						"Accept-Language": "ru",
					})
				};
				return this.http.post<AbstractionsYaDelivery.ClaimsDTO>(url, data, { params, headers: options.headers });
			}
		},
		accept: {
			post$: (data: AbstractionsYaDelivery.ClaimsDTO, claim_id: string): Observable<AbstractionsYaDelivery.ClaimsDTO> => {
				const url = `${this.apiProxyUrl}/claims/accept`;
				let params = new HttpParams();
				params = params.set("claim_id", claim_id);
				const options = {
					headers: new HttpHeaders({
						"Accept-Language": "ru",
					})
				};
				return this.http.post<AbstractionsYaDelivery.ClaimsDTO>(url, { version: data?.version }, { params, headers: options.headers });
			}
		},
		info: {
			post$: (claim_id: string): Observable<AbstractionsYaDelivery.YandexDeliveryDto> => {
				const url = `${this.apiProxyUrl}/claims/info`;
				let params = new HttpParams();
				params = params.set("claim_id", claim_id);
				const options = {
					headers: new HttpHeaders({
						"Accept-Language": "ru",
					})
				};
				return this.http.post<AbstractionsYaDelivery.YandexDeliveryDto>(url, {}, { params, headers: options.headers });
			}
		},
		cancelInfo: {
			post$: (claim_id: string): Observable<AbstractionsYaDelivery.ClaimsCancelInfo> => {
				const url = `${this.apiProxyUrl}/claims/cancel-info`;
				let params = new HttpParams();
				params = params.set("claim_id", claim_id);
				const options = {
					headers: new HttpHeaders({
						"Accept-Language": "ru",
					})
				};
				return this.http.post<AbstractionsYaDelivery.ClaimsCancelInfo>(url, {}, { params, headers: options.headers });
			}
		},
		cancel: {
			post$: (data: AbstractionsYaDelivery.ClaimsCancel, claim_id: string): Observable<AbstractionsYaDelivery.ClaimsDTO> => {
				const url = `${this.apiProxyUrl}/claims/cancel`;
				let params = new HttpParams();
				params = params.set("claim_id", claim_id);
				const options = {
					headers: new HttpHeaders({
						"Accept-Language": "ru",
					})
				};
				return this.http.post<AbstractionsYaDelivery.ClaimsDTO>(url, data, { params, headers: options.headers });
			}
		},
	};
}
